function Text() {
    return(
        <div className="margin">
            <h1 className="mb-2 title">About Tom's Electric</h1>
            <div className="mb-5 pt-0 about-text">
                Tom is a licensed master electrician with over 19 years of experience, specializing in residential installations, panel upgrades, and specialty services.
                With a passion for delivering high-quality, reliable services, he founded Tom's Electric Inc. to provide personalized electrical solutions to the Suffolk County area.
                As a solo operator, Tom personally manages every project, ensuring that each job is completed to the highest standards.
                His commitment to excellence and customer satisfaction sets him apart—he takes pride in offering practical solutions, educating clients, and building lasting relationships.
                Tom was born and raised in Poland, which has fostered a strong connection to the local Polish community and its traditions.       
            </div>
        </div>
    )
}

export default Text; 